import * as React from 'react';
import type { ISODateRange, ISODateString } from 'shared/src/date-string-utils/types';
import { DateRangeField } from './date-range-field';

type Props = {
  id?: string;
  value: ISODateRange;
  onChange: (value: ISODateRange) => void;
  minDate: ISODateString;
  maxDate: ISODateString;
  error?: string;
  warning?: string;
};

export function DatesField({ id, value, onChange, minDate, maxDate, error, warning }: Props) {
  // Flight dates are always editable within the campaign date bounds, regardless of
  // promotion status or pacing type. Moving a date so the range excludes a period that
  // already had spend surfaces a non-blocking warning (passed via `warning`) rather than
  // disabling/pinning/clamping the picker.
  return (
    <DateRangeField
      id={id}
      label="Line Item Start & End Dates"
      description="Select the start and end dates."
      value={value}
      onChange={onChange}
      minDate={minDate}
      maxDate={maxDate}
      error={error}
      warning={warning}
    />
  );
}
